<template>
    <div class="teacherList">
        <span v-for="(item,index) in RecommendCourse.teacherList" :key="index">
          {{item.name}}{{index != RecommendCourse.teacherList.length - 1 ? '、' : ''}}
        </span>
    </div>
</template>
<script>
export default {
  props: ['RecommendCourse'],
  data() {
    return {

    };
  },
};
</script>
<style lang="scss" scoped>
    .teacherList {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        width: 25%;
        height: 10%;
        padding: 25px 30px 0;
        overflow: hidden;
        font-size: 25px;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: #fff;
    }
</style>
